import {useMutation} from '@tanstack/react-query';
import TournamentRestClient from '@/Api/TournamentRestClient';

export default function useVerifyTournamentPassword(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation({
    mutationFn: async ({
      tournamentId,
      password,
    }: {
      tournamentId: number;
      password: string;
    }) => {
      const response = await TournamentRestClient.post(
        `/tournament/verify-password`,
        {
          tournamentId,
          password,
        },
      );
      return response.data;
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });

  return mutation;
}
